module.exports = __webpack_public_path__ + "static/media/video-placeholder.c282f8d4.png";